
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
    "currency": {
      "bb": "Exchange",
      "bba": "Compte d'échange",
      "hy": "Contrats",
      "jg": "Trading d'options",
      "jg1": "Contrats à terme",
      "hya": "Compte Futures"
    },
    home:{
      user:'Choix commun des utilisateurs',
      start:'Commencer à trader',
      trading:'Produits commerciaux',
      fee:'Frais de traitement minimum',
      co:'Co',
      varieties:'Variétés commerciales',
      leading:"Diriger l'innovation et l'exploration du web3",
      market:'Tendances du marché des produits commerciaux',
      explore:'Explorez des possibilités infinies',
      newcurrency:"La nouvelle fonction d'abonnement aux devises est en ligne !'",
      alimited:'Les nouvelles pièces sont en ligne, vous pouvez acheter de nouvelles pièces qui, selon vous, ont du potentiel ici',
      get_start:'Commencez',
      ai_coin:'Le plan de gain de pièces AI est en cours',
      ai_text:"Commencez à gagner des pièces avec l'IA, un revenu stable, un taux de rendement élevé, vous permettant de gagner des pièces en position couchée",
      loan:'La fonction de prêt est en ligne',
      loan_text:"Lorsque vous n'avez pas d'argent, vous pouvez demander un prêt et il sera émis le jour même.",
      mobile_pc:'Utilisé par les infirmières sur PC mobile',
      pc_anytime:'Commencez à trader à tout moment et en tout lieu :',
      pc_text:"Nous mettons à disposition de puissants outils d'analyse de graphiques : plus d'une cinquantaine d'indicateurs techniques et d'outils d'analyse de disque. Un effet de levier sûr, fiable, facile à utiliser et des fonctionnalités à effet de levier élevé sont devenus la plate-forme standard pour l'investissement en ligne.",
      mobile_down:'cliquez pour télécharger',
      mobile_android:'Marché Android',
      mobile_ios:'Apple Store',
      open_text:'Vous pouvez demander un compte de trading réel ou essayer un compte démo gratuitement pour un tiers du coût.',
      open_account:'un compte',
      tocomplete:'compléter',
      walletlogin:'Connexion au portefeuille'
    },
    "index": {
        "h24": "Volume 24H",
        "header_title": ["Choisissez le trading d'actifs numériques " + window.GLOBAL.LANG_TITLE.zh],
        "header_small_title":"Terminez la transaction d'actifs numériques blockchain à guichet unique",
        "header_msg": 'Sûr-stable-digne de confiance',
        "register_title": 'Enregistrez un ' + window.GLOBAL.LANG_TITLE.zh + ' compte mondial commence le voyage de trading',
        "register_pl": 'Veuillez entrer votre email ou votre téléphone portable',
        "register": "S'inscrire",
        "featureMsg": "",
        "featureTitleWhy": 'Pourquoi nous choisir',
        "featureTitle": 'Sûr · stable · fiable',
        "featureMsg": '',
        "featureList": [
        { icon: icon1, title: 'Technologie de portefeuille sécurisé', msg: ["La technologie des portefeuilles froids et chauds est développée par la meilleure équipe de sécurité au monde et il n'y a jamais eu d'incident de perte de pièces.",''] },
        { icon: icon2, title: "Entreprise d'actifs cryptographiques riches", msg: ["La prise en charge du trading au comptant et de plusieurs dérivés, etc., est votre intendant personnel dans le monde des actifs cryptés.",''] },
        { icon: icon3, title: "Des clients répartis dans le monde entier", msg: ["Fournissez une gamme complète de services d'actifs cryptés aux utilisateurs dans plus de 130 pays ou régions du monde.", ''] }
        ],
        bannerList: [
          {icon :banner01,title: "Engagé à fournir une sécurité et une stabilité à la pointe de l'industrie", msg:["des contrats intelligents pour protéger la sécurité des actifs des investisseurs", "les performances de trading réelles", "une garantie de service 24h/24"] },
          {icon: banner02,title: "Je souhaite acheter et vendre immédiatement par le biais d'opérations simples", msg:["écran de trading simple", "immédiatement reflété dans le solde de votre compte", "la plupart des crypto-monnaies peuvent être échangées"] },
          {icon: banner03,title: "Je veux gagner activement des bénéfices grâce au trading de contrats de règlement", msg:["Ouvrir un compte en même temps", "Investissement stratégique pour un grand nombre de contrats à terme", "Vous pouvez trader 24 heures par jour, 365 jours par an, même le week-end"]}
        ],
        featureList2: [
          {icon : icon1_01,title:"Transparency and Openness", msg:["Utiliser les caractéristiques de la blockchain et des contrats intelligents, réaliser les performances des transactions sur la chaîne et utiliser des contrats intelligents pour assurer la sécurité des actifs des investisseurs",""] },
          {icon: icon1_02,title:"Smart Investment", msg:["Avec les stratégies diversifiées fournies par les meilleurs experts en trading quantitatif, vous êtes libre de choisir",""] },
          {icon : icon1_03,title:"Risk grading", msg:["Concevoir des produits d'investissement diversifiés en fonction des différents risques et préférences de gestion d'actifs de chaque investisseur, en éliminant efficacement les seuils d'investissement", ""] },
          {icon : icon1_04,title:"Produits diversifiés", msg:["Fournir divers types de besoins d'investissement des utilisateurs et des mécanismes de plate-forme flexibles, et continuer à produire des services financiers innovants qui sont meilleurs que le marché", ""]}
        ],
        "featureTitle2": "Transaction de terminal multi-plateforme à tout moment, n'importe où",
        "featureMsg2": "Couvrant plusieurs plates-formes d'iOS et d'Android, prenant en charge les fonctions de service complet",
        "tab": ['Monnaie principale', "Liste d'augmentation 24H"],
        "thead": ['Paire de trading', 'dernier prix', 'Prix ​​le plus élevé du jour', 'Le plus bas du jour', 'Augmenter la liste', 'Volume 24H', 'Opération'],
        "more": 'voir plus >',
        "btn": 'transaction',
        "dealsTitle": 'Service commercial à guichet unique',
        "dealsTab":[
        { title: 'Exchange', content: "Le trading de devises est destiné à l'échange entre actifs numériques, en utilisant l'USDT comme unité d'évaluation pour acheter d'autres devises."+window.GLOBAL.LANG_TITLE.zh+"Les transactions en devises prennent en charge les transactions en temps réel d'actifs numériques tels que Bitcoin, Ethereum et Litecoin.", src:'/static/image/deals-1.jpg', path: '' },
        { title: 'Futures', content: "Un dérivé financier d'une monnaie numérique prend non seulement en charge le choix d'acheter des contrats longs ou courts pour gagner un revenu, mais est également simple à utiliser et n'expire jamais."+window.GLOBAL.LANG_TITLE.zh+"Le contrat dispose d'un système avancé de gestion des risques avec un effet de levier jusqu'à 100 fois.", src:'/static/image/deals-2.jpg', path: '' }
        ]
    },
    "market": {
        "tab": ['En option', 'Contrat', 'Pièces de monnaie'],
        "thead": ['Devise', 'Dernier prix', 'Changement 24H', '24H minimum', '24H le plus haut','Volume 24H', 'Opération'],
        "nodata": "Aucune donnée disponible"
    },
    footer: {
        p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
        dd: [
          {
            dt: "A propos de nous",
            dd: [{ title: "Profil de la société", id: 1 }, { title: "Centre d'aide", type: 'help' }]
          },
          {
            dt: "Assistance aux utilisateurs",
            dd: [
              { title: "Accord de l'utilisateur", id: 3 },
              { title: "Politique de confidentialité", id: 5 }
            ]
          },
          {
            dt: "Nous contacter",
            icon: true
          }
        ],
        terms: "Termes et conditions",
        serve: "Servir",
        product: "produit",
    },
    "nav": {
        btn: ["Connexion", "S'inscrire", "Gestion des actifs", "Télécharger l'APP"],
        nav: [
            // { title: "Accueil", path: "/index",name: 'index' },
            // { title: "Exchange", path: "/deal",name: 'deal' },
            { title: "Marché", path: "/market",name: 'market' },
            { title: "Commerce", path: "/preciousMetal", name: 'preciousMetal'},
            // { title: "Exchange", path: "/deal", name: 'deal'},
            // { title: "Futures", path: "/deal_c", name: 'deal_c' },
            // { title: "Crypto-monnaie", path: "/deal_jg", name: 'deal_jg' },
            // { title: "AI Gagner des pièces", path: "/profit_index",name: 'profit_index' },
            { title: "Financière", path: "/profit_index",name: 'profit_index' },
            { title: "Activités", path: "/sign",name: 'sign' }
          ],
        nav2: [{ title: "Mes Avoirs", path: "/asset" }],
        menus: [
        { icon: langzh, title: "Centre d'utilisateurs", path: "/setting" },
        { icon: langen, title: "se déconnecter" }
        ],
        lang: [
          { icon: langen, lang: "English", key: 'en' },
          { icon: langxby, lang: "España", key: 'es' },
          { icon: langfy, lang: "français", key: 'fr' },
          { icon: langdy, lang: "Deutsche", key: 'de' },
          { icon: langjp, lang: "日本語", key: 'jp' },
          // { icon: langar, lang: "عربي", key: 'ar' },
          { icon: langhy, lang: "한국어", key: 'kr' },
          { icon: langty, lang: "ไทย", key: 'th' },
          { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
          { icon: langzh, lang: "简体中文", key: 'zh' },
          { icon: langtw, lang: "繁體中文", key: 'tw' },
        ]
    },
    "download": {
      "xz": "Télécharger"
    },
    // "login": {
    //     login: "Connectez-vous s'il vous plaît",
    //     msg: "Veuillez entrer votre compte enregistré",
    //     list: ['Mobile/Email','Mot de passe','Mot de passe oublié ?','Connexion','Pas de compte, inscrivez-vous maintenant'],
    //     message: "Le compte ou le mot de passe ne peut pas être vide"
    // },
    "register": {
        "dl": [
            "Inscription avec le Numero de téléphone",
            "Inscription avec l'E-mail"
        ],
        title: 'Enregistrez un compte',
        country: 'Pays de citoyenneté',
        country_info: "Les informations sur la nationalité ne peuvent pas être modifiées après l'inscription, veuillez vous assurer de choisir honnêtement",
        code_unit: 'deuxième',
        code_no_data: 'le code de vérification doit être rempli',
        pid_text: "Code d'invitation",
        pid_pl: 'Optionnel',
        invitation_code_no_data: "Le code d'invitation est requis",
        xy: "Accord de l'utilisateur",
        xy_no_checked: "Veuillez sélectionner l'accord",
        agree: "J'ai lu et accepté",
        bz: ["Les informations sur la nationalité ne peuvent pas être modifiées après l'inscription, veuillez vous assurer de choisir honnêtement.", "L'e-mail de vérification peut être considéré à tort comme un spam, veuillez le vérifier attentivement.", 'Veuillez garder votre' + window.GLOBAL.LANG_TITLE.zh + 'Numéro de compte et mot de passe de connexion.', "N'utilisez pas le même mot de passe de connexion que d'autres sites Web."],
        "account": "Numéro de compte",
        "code_text": "Veuillez entrer le code de vérification",
        "code_btn": "Obtenir CAPTCHA",
        "password_text": "Veuillez entrer votre mot de passe",
        "password_again_text": "Veuillez entrer à nouveau votre mot de passe",
        "register_btn": "S'inscrire",
        "account_no_data": "Le numéro de compte ne peut pas être vide",
        "password_no_data": "Le mot de passe ne peut pas être vide",
        "password_no_equality": "Les deux mots de passe ne correspondent pas"
    },
    "bindmpwd": {
        title: 'définir le mot de passe',
        code_unit: 'deuxième',
        code_no_data: 'le code de vérification doit être rempli',
        code_no_equality: 'Les codes de vérification ne sont pas égaux',
      "account": "Numéro de compte",
      "code_text": "Veuillez entrer le code de vérification",
      "code_btn": "Obtenir CAPTCHA",
      "password_text": "Veuillez entrer votre mot de passe",
      "password_again_text": "Veuillez entrer à nouveau votre mot de passe",
      "password_no_data": "Le mot de passe ne peut pas être vide",
      "password_no_equality": "Les deux mots de passe ne correspondent pas",
      "bindmpwd_btn": "Confirmer",
      "phone_no_data": "Le numéro de mobile ne peut pas être vide",
      "password_login_text": "Veuillez entrer votre mot de passe de connexion",
      "password_trade_text": "Longueur du mot de passe : 6 chiffres",
      "password_again_tarde_text": "Longueur du mot de passe : 6 chiffres"
    },
    "forgetpwd": {
        title: ['Modifier le mot de passe', 'Mot de passe oublié'],
        code_unit: 'deuxième',
        code_no_data: 'le code de vérification doit être rempli',
        code_no_equality: 'Les codes de vérification ne sont pas égaux',
      "account": "Numéro de compte",
      "code_text": "Veuillez entrer le code de vérification",
      "code_btn": "Obtenir CAPTCHA",
      "password_text": "Veuillez entrer votre mot de passe",
      "password_again_text": "Veuillez entrer à nouveau votre mot de passe",
      "phone_no_data": "Le numéro de mobile ne peut pas être vide",
      "account_no_data": "Le numéro de compte ne peut pas être vide",
      "password_no_data": "Le mot de passe ne peut pas être vide",
      "password_no_equality": "Les deux mots de passe ne correspondent pas",
      "forgetpwd_btn": "Confirmer"
    },
    "person": {
        no_more: 'Plus de données',
        index_center:"Centre d'utilisateurs",
        index_menus: [
          { icon: zhsz, title: "Gestion de compte", path: '/setting' },
          { icon: sfrz, title: "Authentification KYC", path: '/sfyz' },
          { icon: sfrz, title: "Certification junior", path: '/smauth' },
          { icon: sfrz, title: "Vérifié", path: '/seniorauth' },
          { icon: jtrz, title: "Authentification d'adresse", path: '/dzrz' },
          { icon: jtrz, title: "Achet rapide Crypto", path: '/kjmbSelect' },
          { icon: jtrz, title: "Pointage de crédit", path: '/credit' },
          { icon: jtrz, title: "record", path: '/deallog' },
          { icon: jtrz, title: "Historique des dépôts", path: '/cbjl' },
          { icon: jtrz, title: "Historique des retraits", path: '/tbjl' },
        ],
        xyf: {
            'title': 'Pointage de crédit',
            'pgsj': "Temps d'évaluation"
        },
      "more": "Charger plus",
      "cbtb": "Dépôt et retrait",
      "jymx": "Détails de la transaction",
      "smrz": {
        title:'Vérifié' ,
        sure_title:"Vous avez réussi l'authentification par nom réel",
        zj_info:["1. Les informations de certification ne peuvent pas être modifiées une fois vérifiées, veuillez les remplir honnêtement","2. Les informations de nom réel authentifiées ne peuvent pas être ré-authentifiées"],
        zj_rebtn:'Revérifier' ,
       zj_sebtn:'Vérification avancée' ,
       zj_type_array:[{name:"Carte d'identité",type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "Carte d'identité"
        },
        {
            id: 2,
            name: "Passeport"
        },
        {
            id: 3,
            name: "Permis de conduire"
        },
        {
            id: 4,
            name: "permis de séjour"
        },
        {
            id: 5,
            name: "Autres types de pièces d'identité"
        }
       ],
       "zj_data":{city:'La nationalité ne peut pas être vide',type:"Le type d'identifiant ne peut pas être vide",name:'Le nom ne peut pas être vide',zj_num:"Le numéro d'identification ne peut pas être vide"},
        "zj_type": "Types de pièces d'identité",
        "zj_name": "Nom",
        "zj_num": "Numéro d'identification",
        "zj_btn": "Confimer",
        "zsxm": "Nom réel",
        "qsrzsxm": "Veuillez entrer votre vrai nom",
        "zjlx": "Types de pièces d'identité",
        "qxzzjlx": "Veuillez sélectionner le type de pièce d'identité",
        "sfz": "Carte d'identité",
        "zjhm": "Numéro d'identification",
        "qsrzjhm": "Veuillez entrer votre numéro d'identification",
        "sczjz": "Téléverser une photo d'identité",
        "zjzm": "Téléverser la photo du recto de la pièce d'identité",
        "zjfm": "Téléchargez la photo du verso de la pièce d'identité",
        "scqmz": "Télécharger les documents d'identité et votre signature personnelle",
        "qsczjzmz": "Veuillez télécharger la photo avant de votre pièce d'identité",
        "qsczjbmz": "Veuillez télécharger une photo du dos de votre pièce d'identité",
        "qscgrqmz": "Télécharger une pièce d'identité et une photo de signature",
        "tj": "Soumettre",
        "shz": "En cours de vérification",
        "shtg": "Vérifié"
      },
      "gjrz": {
        "title": "Certification avancée",
        zj_info:['1. Les images inférieures à 8 Mo et aux formats JPG, JPEG ou PNG sont acceptées.',"2. Les photos des documents d'identité doivent être claires et ne doivent pas être modifiées ou obstruées. Le numéro du document d'identité avec photo et le nom du titulaire du document doivent être clairement visibles.","3. Les photos doivent être prises la tête nue, sans couvre-chef et il est recommandé de ne pas se maquiller. Les traits du visage sur la photo doivent être clairs et reconnaissables et les bras doivent être entièrement exposés."],
        zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],
      },
      "zhgl":{
        "title":'Les paramètres de sécurité',
        "bind":[{bind_title:'réinitialiser le mot de passe',bind_name:'boites aux lettres'},{bind_title:'Définir le mot de passe de la transaction',bind_name:'boites aux lettres'}]
      },
      "wdtg": {
        "own_push_title": "Mes promotions"
      },
      "jyzt_td": [
        "Temps",
        "Détails",
        "Montant"
      ],
      "cbjl_td": [
        "Temps",
        "Devise",
        "Quantité"
      ],
    "sfrz_txt": ['Authentification', "Vous avez soumis l'avis, veuillez attendre le résultat", "Vous avez réussi la certification avancée','Avant de la carte d'identité", "Verso de la carte d'identité", 'Attestation',"Échec de l'authentification, veuillez vous ré-authentifier"],
    "zhsz_txt": ['Le niveau de sécurité de votre compte: #', "Le niveau de sécurité de votre compte: #，Améliorer plus d'informations pour assurer la sécurité du compte"],
    "zhsz_m": 'Fort',
    "zhsz_n": 'faible',
    "zhsz_p": 'Pas sécurisé',
    "zhsz_detailList": [
        { icon: '/static/image/User_Center-password.png', title: 'mot de passe', value: "Les comptes Internet risquent d'être volés, il est recommandé de changer régulièrement de mot de passe pour protéger la sécurité de votre compte.",value2:'', btn: 'modifier',bind_email:"Veuillez d'abord lier votre e-mail ou votre téléphone portable", path: '/forgetpwd?type=changepwd' },
        { icon: '/static/image/User_Center-password.png', title: 'mot de passe de transaction', value: 'définir le mot de passe', btn: 'Aller à définir', path: '/bindmpwd' }
    ],
    "sksz_txt": ['Paramètres de collecte', 'sauvegarder'],
    },
    "pasination": {
      "first": "Accueil",
      "prev": 'Page précédente',
        "next": 'Page suivante',
        "last": 'dernière page',
      "no_data": "Aucune donnée disponible"
    },
    "asset": {
      "title": "Mes Avoirs",
      "zjhz": 'Transfert de fonds',
      "gz": 'Valorisation en USDT',
      "cb": "Dépôt",
      "zh_title": 'Total des actifs convertis：',
      "index_title": 'les atouts',
      "address_title": "Devise",
      "address_txt": ['Veuillez sélectionner','Adresse de retrait','Veuillez saisir le contenu','Remarques',"Liste d'adresses"],
      "address_btn": ['Ajouter', 'Enregistrer', 'Supprimer', 'Modifier'],
      "address_td": [
        "Devise",
        "Adresse de retrait",
        "Remarque",
        "Opération"
      ],
      "currency_td": [
        "Devise",
        "Disponible",
        "Geler",
        "Convertir"
      ],
      "table_title": 'Actif total：',
      "table_address_title": 'Gestion des adresses de retrait',
      "table_td": [
        "Devise",
        "Disponible",
        "Geler",
        "Convertir",
        "Opération"
      ],
      "table_btn": ['Dépôt', 'Retrait', 'enregistrement', 'Transfert'],
      "money_text": ['Adresse de retrait', "Choisissez s'il vous plaît", 'Quantité', 'Disponible：', 'Frais','Montants crédités', 'Mot de passe de paiement','Tags(Memo)','Retrait minimum '],
      "money_btn": "Retrait",
      "xzbz": "Sélectionnez la devise",
      "recharge_title": 'Adresse de recharge',
      "recharge_btn": [
        "Copier",
        "Code QR",
        "Dépôt"
      ],
      "recharge_text": ['Quantité', 'Rappel', "Veuillez ne pas déposer d'actifs non USDT à l'adresse ci-dessus, sinon les actifs ne seront pas récupérés.", "Les dépôts en USDT ne prennent en charge que la méthode d'envoi simple. Les dépôts utilisant d'autres méthodes (tout envoyer) ne peuvent pas être publiés temporairement. Veuillez comprendre.", 'certificat', 'Description du bon(Optionnel)','Nom de la chaîne'],
      "record_title": 'Documents financiers',
      "record_td": ['Quantité', 'enregistrement', 'Temps'],
      "transfer_btn": ['Tous', 'Transfert'],
      "transfer_text": ['De', 'à', 'Veuillez saisir le montant du virement', 'Disponible：'],
      "transfer_title": "Transfert",
      "bq": "Tags(Memo)",
      "qsrbq": "Veuillez entrer le tag",
      "yhktx": "Retrait par carte bancaire",
      "yhmc": "Nom de la banque",
      "qsryhmc": "Veuillez entrer le nom de votre banque",
      "yhzh": "Numéro de compte bancaire",
      "qsryhzh": "Veuillez saisir le numéro de compte bancaire",
      "gjhkdm": "Code SWIFT",
      "qsrgjhkdm": "Veuillez saisir le code SWIFT",
      "yhdz": "Adresse de la banque",
      "qsryhdz": "Veuillez saisir l'adresse de la banque",
      "skrxm": "Nom du bénéficiaire",
      "qsrskrxm": "Veuillez saisir le nom du bénéficiaire",
      "skrdh": "Téléphone du bénéficiaire",
      "qsrskrdh": "Veuillez saisir le numéro de téléphone du bénéficiaire",
      "skrdz": "Adresse du bénéficiaire",
      "qsrskrdz": "Veuillez saisir l'adresse du bénéficiaire"
    },
    "text": {
        "btn": 'revenir',
        "login": "s'il vous plait Connectez-vous d'abord"
    },
    "deal": {
        "chooseType": 'Type de commission',
        "choose": "Choisissez s'il vous plaît",
        "balance": 'Équilibre：',
        "account": ['Compte', 'Disponible', '/Geler', 'Transfert'],
      "dir": [
        "Acheter",
        "Vendre"
      ],
      "dir2": [
        "Disponible à l'achat",
        "Disponible à la vente"
      ],
      "cs": "En option",
      "sxf": "Taux de commission",
      "jye": "Montant de la transaction",
      "sc_h": ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
      "td_lt": ['Devise', 'Dernier prix', 'Augmenter'],
      "k_line_txt": ['≈', '', 'Augmenter', 'Le prix le plus élevé', 'Prix ​​le plus bas', 'Volume 24H'],
      "tabListRTitle": ["Limiter la transaction", "Opération de marché"],
      "tabListLTitle": [
        "Ordres ouverts",
        "Historique des commissions"
      ],
      "tabListLEntrust": [
        "Acheter",
        "Vendre"
      ],
      "table_btn": [
        "Annuler l'ordre"
      ],
      "index_td_l": ['Temps', 'Partenaires commerciaux', 'Quantité', 'Prix', 'Opération'],
      "index_td_r2": ["Dernière transaction", 'Temps', 'Prix', "Volume d'échanges"],
      "index_td_r": [
        "Dernier prix",
        "Direction",
        "Prix",
        "Quantité"
      ],
      "table_txt": [
        "Exécuté",
        "Retiré"
      ],
      "db_1_txt": ['Disponible', "prix d'achat", 'Prix ​​de vente', "Volume d'achat", "Volume de vente", 'Montant de la transaction', 'Achetez au meilleur prix du marché', 'Vendre au meilleur prix du marché', 'Acheter la main', 'Vendre la main'],
      "db_2_txt": ['Prix', 'Effet de levier', "Choisissez s'il vous plaît", 'Nombre de lots', '1lot =', 'lot', 'Valeur Marchande', 'Marge', 'Achetez au meilleur prix du marché', 'Vendre au meilleur prix du marché'],
      "pathList": ['Enregistrement du contrat','Enregistrement de la transaction'],
      "db_btn": ['Acheter (long)', 'Vendre (court)'],
      "tabListLTitle2": [
        "Ordres ouverts"
      ],
      "lt_btn": ['Liquidation en un clic', 'Définir le prix du stop profit et du stop loss', 'Position fermée', 'Soumettre maintenant', 'revenir'],
      "lt_txt": ['风险率：', 'Bénéfice Total：'],
      "lt_td": ['Type','Effet de levier', 'Position Prix', 'Prix actuel', 'Marge', 'Prendre des bénéfices', 'Prix du Stop Loss', 'Temps ouvert', 'Nombre de lots', 'Profits et pertes', 'Opération'],
      "lt_dl": ['Définir le prix du stop profit et du stop loss', 'Prendre des bénéfice', 'Prix du Stop Loss'],

      "lt_0_btn": [
        "Annuler l'ordre"
      ],
      "lt_0_td": ['détails du contact', 'Devise', 'Quantité', 'Prix actuel', 'Frais', 'Opération'],
      "lt_1_btn": [
        "Position fermée"
      ],
      "lt_1_txt": [
        "Clôture"
      ],
      "lt_1_td": ['Type', 'Position Prix', 'Prix actuel', 'Marge', 'Prendre des bénéfices', 'Prix du Stop Loss', 'Temps ouvert', 'Frais', 'Profits et pertes', 'Opération'],
      "node_data": "Aucune donnée disponible",
      "lt_3_txt": ['Fermé', 'Liquidation'],
      "lt_3_td": ['Type', 'Nombre de lots', 'Position Prix', 'Le dernier prix', 'Prendre des bénéfices', 'Prix du Stop Loss', 'Marge', 'Marge disponible', 'Temps ouvert', 'Heure de fermeture', 'Frais','Profits et pertes', 'Opération'],
      "lt_4_txt": [
        "Retiré"
      ],
      "cm": ["Heure d'émission", "Numéro d'émission", '流通总量', '总凑价格', 'Site web officiel','Livre blanc','介绍'],
      "qsrsl": "Veuillez saisir le montant",
      "qsrss": 'Veuillez saisir le lot',
    },
    "notice":{
        "notice_title": "Centre d'annonces",
    },
    "bzhl": {
      "title": "AI Gagner des pièces",
      "title1": "Quantification de l'IA",
      "ttzbt": "Gains quotidiens",
      "wdtg": 'Mon hébergement',
      "zztgdzj": "Fonds en dépôt",
      "yjjrsy": 'Estimation quotidienne',
      "ljsy": "Bénéfices cumulés",
      "tgzdd": "Ordres en dépôt fiduciaire",
      "tgdd": "Ordre de dépôt fiduciaire",
      "t1": 'Gestion financière saine et à faible risque, remboursable à tout moment si nécessaire',
      "t2": "Votre assistant de gestion d'argent gratuit",
      "cljxcp": "Cycle du produit",
      "dbxe": "Limite unique",
      "rsyl": "Rendement quotidien (%)",
      "rsyl2": 'Rendement quotidien：',
      "zq": "Cycle",
      "qmr": 'Aller acheter',
      "ckgd": 'voir plus',
      "cpgk": 'Présentation du produit',
      "pxsj": "Date de versement des dividendes",
      "tgzj": "Capital en dépôt",
      "tqsh": 'Remboursement anticipé',
      "cpld": "Points forts du produit",
      "cpgz": 'Règles du produit',
      "cont": "Le déplacement de brique se fait en hébergeant l'USDT sur la plate-forme, et l'équipe professionnelle de la plate-forme exerce le droit de déplacer des briques. Les participants peuvent obtenir la part de la plate-forme des revenus du déplacement de brique pendant la période de conservation du fonds, accessible à tout moment, ce qui est sûr et pratique.",
      "zj": "Fonds à 100%.",
      "aqbz": "Sécurité",
      "jjrsy": "Revenus de vacances",
      "bjd": "Ininterrompu",
      "cgcrh": "Après un dépôt réussi",
      "dtqx": "Valeur des intérêts le jour même",
      "ljzr": 'Transférer maintenant',
      "xqglgj": "Outils de gestion d'argent gratuits",
      "ddh": "Numéro de commande",
      "tgje": "Montant détenu en fiducie",
      "tgsj": 'Jours par cycle',
      "yhl": "Bénéfice gagné / Jours restants",
      "xdsj": "Heure de la commande",
      "zt": 'statut',
      "fh": 'revenir',
      "tzfx": "risque d'investissement",
      "shsc": 'Temps de rachat',
      "di": "Bas",
      "yggzr": 'Un jour ouvrable',
      "msgsxf": "Frais d'abonnement gratuit",
      "mr": "Journalier",
      "dqfh": "Rendement à l'échéance",
      "ljgm": "Achat immédiat",
      "tgz": "En dépôt fiduciaire",
      "sh": "Rachat",
      "ywc": "Exécuté",
      "ysh": "Remboursé",
      "all": "Tous",
      "xzbzts": "Simple et sûr. Les dividendes peuvent être sélectionnés dans plusieurs devises",
      "qtbz": "Autres pièces"
    },
    "pay":{
        "qsrjymm": 'Veuillez saisir un mot de passe de transaction à 6 chiffres',
        "tbmmts": "Veuillez vous rendre dans l'espace utilisateur pour définir le mot de passe de la transaction",
    },
    "tips": {
      "qxztbdz": "Veuillez entrer l'adresse de retrait",
      "qsrtbsl": "Veuillez saisir le montant de la devise de retrait"
    },
    "statusText": ['Erreur','En attente de traitement','Succès'],
    "dzrz": {
        title: "Authentification d'adresse",
        sdddz: 'Adresse de facturation des services publics',
        zdtpsc: "Téléchargement d'image de facture",
        qsrsdddz: "Vous devez remplir les informations d'adresse et soumettre la facture d'électricité ou la facture d'adresse à large bande",
        qsczdtp: 'Veuillez télécharger une photo de la facture',
            "status": [
            "En cours de vérification",
            "Vérifié"
       ],
       "qd": "Confimer"
    },
    "jgcc": {
      "wtgd": "Ordre en attente",
      "cj": "Transaction",
      "jj": "Introduction",
      "zc": "Actif",
      "lszc": "Historique",
      "qblx": "Tous les types",
      "xj": "Prix au comptant",
      "sj": "Temps",
      "fx": "Direction",
      "jg": "Prix",
      "sl": "Quantité",
      "jgsj": "Temps de règlement",
      "gmj": "Prix d'achat",
      "jsj": "Prix de règlement",
      "yk": "Profits et pertes",
      "xq": "Détails",
      "mz": "Haussier",
      "md": "Baissier",
      "dqye": "Solde actuel",
      "gb": "Fermer",
      "jxxd": "Continuer à passer les ordres",
      "qrxd": "Confirmer",
      "ddqr": "Confirmation de l'ordre",
      "sxf": "Frais",
      "kyye": "Équilibre",
      "jypz": "Paires",
      "jyfx": "Direction",
      "tzje": "Montant de l'investissement",
      "tzjeTips": "Le montant de l'investissement ne peut pas être égal à 0",
      "dqsj": "Délai d'expiration",
      "jssj": "Temps de règlement",
      "gmsj": "Temps d'achat",
      "sy": "Gain",
      "zxje": 'Montant minimal ',
      "shi": 'H',
      "fen": 'M',
      "miao": 's',
      "zdje": "Quantité maximale ",
      "qsrje": 'Veuillez saisir le montant',
      "zxtzje": "Le minimum",
      "xq": 'Des détails',
      "ddz": 'Attendre',
      "jgjl": 'Registre de livraison',
      "yebz": "Solde insuffisant",
      "bz": "Devise",
      "cz": "Opération"
    },
    "kjmb": {
      "title": "Achet rapide Crypto",
      "ljmb": "Acheter Crypto",
      "fzcg": 'Copier avec succès',
      "lxkf": 'Contactez le service à la clientèle'
    },
    "news": {
      "title": "Mes messages",
      "gg": "Avis",
      "ckxq": "Afficher les détails"
    },
    "statusTabs":['Commande en cours', 'Trading','Fermé', 'Retiré'],
    "chongzhi":{
      "zy": "Important",
      "cbxx": "Informations sur le dépôt de jetons",
      "qsrsl": "Veuillez saisir le montant du dépôt",
      "tips2": "1. Compatibilité portefeuille/plateforme : c'est-à-dire que le réseau est pris en charge ; si la plate-forme cible ne prend pas en charge votre réseau de retrait, les actifs ne peuvent pas être récupérés.",
      "tips3": "2. Votre réseau de recharge et la plate-forme cible sont les mêmes ; si vous choisissez l'adresse cible est le réseau Ethereum, mais que la recharge choisit la chaîne intelligente TRC20, vous ne pourrez peut-être pas récupérer vos actifs numériques.",
      "tips4": "3. Assurez-vous que votre adresse et votre montant sont corrects avant de recharger.",
      "tips5": "Rappel : En raison de l'anonymat et de la confidentialité du réseau de blocage, une fois que vous avez entré des informations erronées, vous perdrez les actifs correspondants. S'il vous plaît vérifier votre adresse de recharge et la quantité soigneusement",
      "tips2_1": "• Veuillez ne pas facturer d'actifs en devise non locale à l'adresse ci-dessus, sinon les actifs ne pourront pas être récupérés.",
      "tips2_2": "• La monnaie numérique ne peut pas être livrée à temps. L'heure d'arrivée réelle dépend de la vitesse de confirmation de la blockchain.",
      "tips2_3": "• Votre adresse de recharge ne changera pas fréquemment, vous pouvez recharger ; s'il y a un changement, nous ferons de notre mieux pour vous en informer via une annonce sur le site Web ou par e-mail.",
    },
    "tibi":{
      "tbxx": "Informations de retrait",
      "qsrbq": "Veuillez saisir un libellé",
      "tbTips1": "• Pour assurer la sécurité des fonds, lorsque la politique de sécurité de votre compte change, que le mot de passe change, nous examinerons manuellement le retrait, veuillez attendre patiemment que le personnel vous contacte par téléphone ou par e-mail.",
      "tbTips2": "• Assurez-vous que votre ordinateur et votre navigateur sont sécurisés pour empêcher que des informations ne soient falsifiées ou divulguées.",
      "tbTips3": "• L'actif numérique que vous avez mentionné est un actif multi-chaînes à une pièce. Quelle que soit la chaîne à partir de laquelle vous choisissez de collecter, cela signifie que le montant total des actifs numériques affichés sur la page de retrait que vous possédez sera réduit par le montant correspondant levé .",
    },
    "gjlb": "Liste des pays",
    "qxzgjlb": "S'il vous plaît sélectionnez Pays / Région",
    "mbwt":{
      "title": "Paramètres des problèmes de sécurité",
      "mbwt": "Les problèmes de sécurité",
      "problem":[
        {
          "id": 1,
          "title": "Quel était votre meilleur ami quand vous étiez enfant?"
        },
        {
          "id": 2,
          "title": "Qui est ton idole?"
        },
        {
          "id": 3,
          "title": "Où est votre endroit le plus ardent?"
        }
      ],
      "qtxda": "Veuillez remplir la réponse",
      "qsrxmm": "Veuillez saisir un nouveau mot de passe",
      "qqrmm": "Veuillez confirmer votre mot de passe",
      "sydqmmcz": "Utiliser la réinitialisation du mot de passe actuel",
      "zhmm": "Problèmes de sécurité Récupérer le mot de passe",
      "ysz": "A été mis en",
      "tg": "franchir",
    "tj": "nous faire parvenir",
    "zyts": "Important:",
    "zytsCont": "Ne divulguez pas la réponse secrète et le code de vérification, et gardez à l'esprit le problème de sécurité, qui vous aidera à récupérer votre mot de passe"
    },
    "zc":{
      "zclb": "Liste des actifs",
      "zczh": "Conversion d'actifs",
      "yczc": "Masquer les soldes nuls"
    },
    "indexNew":{
      "t1": "Leader mondial",
      "t2": "Plateforme de services d'actifs numériques",
      "t3": "Transaction complète d'actifs numériques blockchain à guichet unique",
      "t4": "Numéro de portable/Email",
      "t5": "Inscrivez-vous maintenant",
      "t6": "Accueillir des clients du monde entier grâce à FXSFC",
      "t7":"Découvrez et démarrez leur parcours de chiffrement"
    },
    "newReg":{
      "dl": ['e-mail','Mobile'],
      "cjzh": "Créer un compte",
      "sysjhzyx": "S'inscrire avec un numéro de portable/e-mail",
      "yhxy": "&lt;Contrat d'utilisation&gt;",
      "yhxy2": "J'ai lu et j'accepte les et &lt;Contrat d'utilisation&gt;",
      "yxgz": "Veuillez entrer un email valide",
      "dhgz": "Le numéro de téléphone portable est incorrect"
    },
    "indexNew2":{
      "t1": "Échanger sur notre commande",
      "t2": "Utiliser Bitbank",
      "t3": "Bitbank est un échange ingénieusement conçu de bitcoins et d'actifs cryptés. Il est très simple, pratique, sûr et puissant. Il prend en charge les transactions sur plusieurs plates-formes Web et smartphones. Les données de transaction et les graphiques sont mis à jour en temps réel. Complet l'analyse des prix du marché fournit plus de 60 outils d'analyse technique.",
      "ksjy": "Commencer à trader",
      "ly": "5 raisons de choisir Bitbank",
      "item1_t1": "Volume de trading leader",
      "item1_t2": "No.1 * Volume de négociation d'actifs cryptographiques",
      "item1_t3": "Liquidité élevée, trading confortable (expérience de trading agréable). Liste 12 types d'actifs cryptographiques.",
      "item2_t1": "Évaluation tierce élevée",
      "item2_t2": "Environnement de trading sécurisé",
      "item2_t3": "Utilisez un portefeuille froid hors ligne. Utilisez Multisig pour empêcher les pirates d'entrer. Protégez vos actifs avec la haute technologie",
      "item3_t1": "Application facile à utiliser et fiable",
      "item3_t2": "Facile à utiliser et application simple",
      "item3_t3": "Une application fiable avec des fonctions riches. Elle peut maintenir des opportunités de trading en dehors de la transaction.",
      "item4_t1": "Ouvert toute la journée",
      "item4_t2": "Peut déposer de l'or",
      "item4_t3": "Support de dépôt de 24 heures, y compris les jours fériés!",
      "item5_t1": "Smartphone et PC",
      "item5_t2": "Conception humanisée",
      "item5_t3": "Même si vous utilisez un smartphone, vous pouvez effectuer des transactions simples et qualifiées sans hésiter",
      "aqkk": "Sûr et fiable",
      "aqkk2": "Transaction Bitbank Bitcoin",
      "cjzh": "Créer un compte",
    },
    "xbsg":{
      "title": "Nouvelle zone de pièces",
      "wdsg": "Des détails",
      "scts": "Jours de fermeture: ",
      "sy": "restant",
      "ljsg": "S'abonner",
      "ysk": "Solder",
      "xzjdy": "S'abonner",
      "dy": "S'abonner",
      "fxjg": "prix d'émission",
      "fxl": "Circulation",
      "ssrq": "Date d'inscription",
      "yxqx": "Période de validité",
      "qsrsl": "Veuillez saisir le montant",
      "syl": "restant",
      "sgrq": "s'abonner",
      "sgsl": "Montant",
      "bz": "Devise",
      "yebz": "Solde USDT insuffisant",
      "tgsl": "Qté de passage",
      "shz": "à l'étude",
      "wtg": "N'a pas passé",
      "ytg": "passé"
    },
    "wydb":{
      "title": "Emprunter",
      "db": "Emprunter",
      "dbz": "Emprunter",
      "jl": "des détails",
      "jdzq": "Période (jours)",
      "qhk": "Rembourser",
      "ljdb": "Cumul (USD)",
      "dhkbs" :"En attente de paiement",
      "jkje": "montant (USD)",
      "qsrje": "Veuillez saisir le montant",
      "rll": "Taux d'intérêt journalier",
      "hkfs": "Remboursement",
      "dqych": "Expiré",
      "lx": "L'intérêt",
      "fkjg": "Prêteur",
      "tpsc": "Prêt de crédit (téléchargement d'image)",
      "fwxx": "Informations sur le logement",
      "srzm": "Preuve de revenu (relation de travail)",
      "yhmx": "relevé bancaire",
      "zjz": "photo d'identité",
      "yd": "j'ai lu et j'accepte",
      "xy": "Demander un contrat de prêt",
      "sqdb": "demander des chaînes de prêt",
      "gb": "fermeture",
      "qd": "d'accord",
      "ts": "Veuillez cocher Demander un contrat de prêt",
      "dbjl": "des détails",
      "hkhth": "Code de commande",
      "wsh": "Non révisé",
      "yfk": "Prêt",
      "sqrq": "temps d'application",
      "zq": "cycle",
      "dbsl": "Nombre de côtes",
      "zhke": "Paiement total",
      "yhkxq": "Détails du remboursement",
      "bqyhk": "Remboursable dans la période en cours(USDT)",
      "hktips": "Veuillez vous assurer que le solde est suffisant, si le solde est insuffisant, veuillez d'abord recharger puis rembourser",
      "bj": "Principal",
      "jie": "Emprunter",
      "ljhk": "Remboursez immédiatement",
      "qcz": "Déposer",
      "yebzqxcz": "Solde insuffisant, veuillez d'abord recharger puis rembourser",
      "znj": "frais de retard",
      "yqts": "Jours en retard"
    },
    "hkxq":{
      "dd":"Commander",
      "fzhkdz":"Copiez l'adresse de remboursement",
      "hkxq": "Détails du remboursement",
      "zlx": "intérêt total",
      "zhk": "remboursements totaux",
      "hkjg": "agence de remboursement",
      "qschkpz": "Veuillez télécharger le certificat de remboursement",
      "hkpz": "certificat de remboursement"
    },
    "bbjyNew":{
      "jylx": "Types de",
      "jyze": "Montant"
    },
    "bind":{
      "title": "E-mail",
      "ybd": "Bondir",
      "wbd": "Non lié",
      "ts": "Pour protéger votre compte, il est recommandé de lier une adresse e-mail",
      "qsryxdz": "Veuillez entrer votre E-mail"
    },
    "tipsNew": {
      "yjj": "rejeté",
      "shz": "rachat"
    },
    "newIndex2":{
      "zxhy": "Dernières citations",
      "jypt": "Plateforme de négociation",
      "ssyc": "Réduire le masquage",
      "hwzc": "Pas encore enregistré ?",
      "ljzc": "Inscrivez-vous maintenant et découvrez des tonnes d'opportunités !",
      "yyzh": "Vous avez déjà un compte ?",
      "hjbj": "Connectez-vous si vous avez un compte, ça fait longtemps !",
      "lmdh": "Navigation par colonne",
      "ghdjy": "Meilleure affaire, meilleure vie",
      "ghdjy02": "Le hub de trading crypto le plus innovant au monde est ici, où vous pouvez acheter, échanger et gagner des crypto-monnaies avec des centaines de crypto-monnaies à portée de main.",
      "indexCont01": "Toujours à côté de vous",
      "indexCont02": "Négociez nos marchés au comptant et sur marge avec des options de financement avancées, une exécution ultra-rapide et une liquidité abondante.",
      "indexCont03": "API puissante",
      "indexCont04": "Gérez sans effort vos positions avec notre API intuitive, notre plateforme de trading et nos options de commande avancées.",
      "indexCont05": "Actifs numériques de haute qualité",
      "indexCont06": "9 ans 0 accident",
      "indexCont07": "Meilleur contrôle des risques de sécurité",
      "indexCont08": "L'effet de levier jusqu'à 25 fois",
      "indexCont09": "Tradez des CFD Bitcoin avec un effet de levier jusqu'à 25x.",
      "indexCont010": "Réserve de sécurité",
      "indexCont011": "Liquidité profonde",
      "indexCont012": "Notre technologie propriétaire avancée de carnet d'ordres multi-marchés améliore la liquidité, resserre les spreads et réduit le glissement.",
      "indexCont013": "Préférences de l'utilisateur",
      "indexCont014": "Pays couvert",
      "indexCont015": "Nos points forts",
      "indexCont016": "Échangez nos marchés au comptant et sur marge avec des options de financement avancées, une exécution ultra-rapide et une liquidité abondante.",
      "indexCont017": "Stockage sécurisé",
      "indexCont018": "Nous utilisons une combinaison de portefeuilles froids et de technologie de calcul multipartite (MPC) pour gérer les actifs numériques.",
      "indexCont019": "La sécurité d'abord",
      "indexCont020": "Nous utilisons les dernières technologies pour protéger vos fonds et garder une longueur d'avance sur les bogues et les tentatives d'exploitation.",
      "indexCont021": "Retrait rapide",
      "indexCont022": "Grâce au calcul multipartite, nous sommes en mesure de fournir des retraits rapides 24h/24 et 7j/7 tout en maintenant nos normes de sécurité strictes.",
      "indexCont023": "Acheter, vendre des cryptomonnaies",
      "indexCont024": "Rejoignez la plateforme de trading la plus complète et la plus sécurisée au monde",
      "indexCont025": "Achetez et vendez Bitcoin, Ethereum, XRP et de nombreuses autres crypto-monnaies en utilisant des fiat ou des crypto-monnaies.",
      "yqwj": "10 millions+",
      "dlzc": "Connectez-vous pour vous inscrire",
      "yzm": "Code de vérification",
      "qrmm": "Confirmer le mot de passe"
    },
    "langNew2":{
      "flzq": "Centre de récompenses",
      "qdjl": "Récompense de connexion",
      "mrqdjl": "Récompense de connexion quotidienne",
      "qd": "S'identifier",
      "yqd": "Connecté",
      "hdgz": "Règles de l'événement",
      "qdjl2": "Enregistrement d'enregistrement",
      "qdcg": "Connectez-vous avec succès",
      "yhd": "Acquis",
      "lq": "Recevoir",
      "dyt": "Jour 1",
      "det": "Jour 2",
      "dst": "Jour 3",
      "dsit": "Jour 4",
      "dwt": "Jour 5",
      "dlt": "Jour 6",
      "dqt": "Jour 7",
      "jxz": "en cours",
      "cjxnzh": "Créer un compte virtuel",
      "sy":"Page d'accueil",
      "sc":"Marché",
      "sclb":"Liste du marché",
      "jy":"Commerce",
      "zh":"Compte",
      "db":"Prêts",
      "zchm":"Numéro d'enregistrement",
      "cp":"Produit",
      "tzjd":"Prêts d'investissement",
      "zxzc":"Support en ligne",
      "xd":"Commande",
      "zzjptgmnr":"Investissez dans votre avenir. Développez votre portefeuille dans un système financier équitable et ouvert.",
      "yy":"Application",
      "pqnr":"Une banque mobile qui s'affranchit des règles traditionnelles et met à votre disposition des outils précis de gestion financière.",
      "jiami":"Cryptomonnaie",
      "tgnr":"En effectuant des dépôts en utilisant la cryptographie, vous bénéficiez d'un niveau de sécurité supplémentaire et garantissez un traitement rapide des transactions.",
      "jyl":"Volume des échanges sur 24 heures",
      "ssjmhb":"Liste des cryptomonnaies",
      "zchy":"Utilisateurs enregistrés",
      "djxz":"Cliquez pour télécharger",
      "azsc":"Marché Android",
      "pgsd":"Apple Store",
      "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    },
    // "langNew":{
    //   "szhb": "Crypto-monnaie",
    //   "gjs": "Métal",
    //   "yy": "Brut",
    //   "jy": "Commerce",
    //   "jmhb": "Crypto-monnaie",
    //   "yxhy": "Contrat perpétuel",
    //   "gdjy": "commande en cours",
    //   "khh": "Banque d'ouverture de compte",
    //   "qsrkhh": "Veuillez saisir la banque",
    //   "yhkh": "Numéro de la carte bancaire",
    //   "qsryhkh": "Veuillez entrer votre numéro de carte bancaire",
    //  },
     "login":{
       login: "Connectez-vous s'il vous plaît",
       msg: "Veuillez entrer votre compte enregistré",
       list: ['Mobile/Email','Mot de passe','Mot de passe oublié ?','Connexion','Pas de compte, inscrivez-vous maintenant'],
       message: "Le compte ou le mot de passe ne peut pas être vide",
       "cdlks":"Commençons par la connexion !",
       "zh":"Compte",
       "qsrzh":"Entrez votre nom d'utilisateur",
       "mm":"Mot de passe",
       "qsrmm":"Entrer le mot de passe",
       "dl":"Se connecter",
       "wjmm":"Mot de passe oublié",
       "qbdl":"Connexion par portefeuille",
       "myzh":"Je n'ai pas de compte ?",
       "zc":"S'inscrire",
       "yzm":"Le code de vérification",
       "qsryzm":"Entrez le code de vérification",
       "hqyzm":"Code envoyé",
       "qrmm":"Confirmez le mot de passe",
       "qsrqrmm":"Confirmez le mot de passe",
       "lcmmbyz":"Les deux entrées de mot de passe sont incohérentes",
       "mmts":"Longueur du mot de passe 6 à 12 caractères",
       "sjtx":"Erreur de format du numéro de téléphone",
       "yxts":"Erreur de format d'e-mail",
       "qr":"D'ACCORD",
       "sjzc":"Mobile",
       "sjh":"Numéro de téléphone",
       "qsrsjh":"Entrez le numéro de téléphone",
       "yqm":"Code d'invitation (facultatif)",
       "qsryqm":"Entrez le code d'invitation",
       "yxzc":"E-mail",
       "wyydbzx":"Accepter",
       "yhxy":"<Contrat de services utilisateur>",
       "yhxy2":"Contrat de services utilisateur",
       "ysyx":"<Accord de protection de la vie privée>",
       "yx":"E-mail",
       "qsryx":"Entrez l'e-mail",
       "yxgsbzc":"Email invalide",
       "cjmnzhcg":"Compte démo créé avec succès",
       "tcmnzh":"Quitter le compte démo",
       "qbdlts":"Veuillez utiliser le portefeuille DAPP",
     },
    //  "index":{
    //    "xgnysx":"Les nouveautés sont en ligne !",
    //    "hyld":"Bienvenue sur notre plateforme de trading financier primée et explorez le futur monde financier avec des investisseurs mondiaux",
    //    "symncz":"Utiliser un compte démo",
    //    "zdjyfy":"Frais de transaction minimaux <0,3%",
    //    "jysyzc":"Négociez tous vos actifs en un seul endroit",
    //    "hbsp":"Forex, crypto-monnaies, actions, indices, matières premières",
    //    "ksjy":"Commencer",
    //    "jdewd":"Simple et stable",
    //    "aizb":"Trading d'IA doré",
    //    "srjh":"Créez votre plan de revenus en un clic",
    //    "kssy":"Commencez à utiliser",
    //    "dlyhggdje":"Des taux d’intérêt bas et des montants plus élevés",
    //    "jmhbdk":"Prêts en crypto-monnaie",
    //    "zmyrhdyp":"Emprunter du spot de crypto-monnaie sans aucune garantie",
    //    "gs":"Entreprise",
    //    "gywm":"À propos de nous",
    //    "xkzjd":"Surveillance des licences",
    //    "bzzx":"Centre d'aide",
    //    "zhengce":"Politique",
    //    "tkytj":"Termes et conditions",
    //    "yszc":"politique de confidentialité",
    //    "sm":"Déclaration",
    //    "flxx":"Information légale",
    //    "mzsm":"Clause de non-responsabilité",
    //    "fxjg":"Avertissement de risque",
    //    "gygg":"À propos de la publicité",
    //    "gg":"Annonce",
    //  },
     "hq":{
       "wh":"Forex",
       "szhb":"Cryptomonnaie",
       "gp":"Action",
       "zs":"Indice",
       "eft":"FNB",
       "mc":"Nom",
       "xs":"24h%",
       "tb":"Graphique",
       "jg":"Prix",
     },
     "user":{
       "wdzh":"Mon compte",
       "zh":"Compte: ",
       "dk":"Prêt: ",
       "sydbzj":"Marge utilisée : ",
       "yqll":"Bénéfice attendu : ",
       "qtgn":"Autres fonctions",
       "cz":"Dépôt",
       "tx":"Retirer",
       "dh":"Échange",
       "zhyz":"Certification KYC",
       "zhjl":"Historique du compte",
       "yqhy":"Inviter des amis",
       "flzq":"Zone de bien-être",
       "ggmm":"Changer le mot de passe",
       "sz":"Paramètres",
       "cjwtjd":"FAQ",
       "fzdz":"Copier l'adresse",
       "sl":"Quantité...",
       "qsrsl":"Entrez la quantité",
       "dd":"Obtenez (USDT) : ",
       "sczm":"Télécharger le bon",
       "qsczm":"Veuillez télécharger le bon",
       "tj":"Soumettre",
       "czjl":"Dossier de dépôt",
       "ddh":"Non.",
       "wsh":"Pas révisé",
       "ywc":"Complété",
       "bz":"Nom: ",
       "sl2":"Quantité: ",
       "sj":"Temps: ",
       "srsl":"Entrez la quantité...",
       "dd2":"Obtenir: ",
       "qskgzflhd":"S'il vous plaît, faites toujours attention aux activités sociales, nous les publierons de temps en temps.",
       "hdlb":"Liste des événements",
       "ckxq":"Voir les détails",
       "wdjl":"Ma récompense",
       "yiji":"Niveau 1",
       "erji":"Niveau 2",
       "sanji":"Niveau 3",
       "je":"Montant",
       "sj2":"Temps",
       "yyxz":"Langue",
       "tcdl":"se déconnecter",
       "je2":"Montant (USD)...",
       "qsrje":"Entrez le montant",
       "jsdz":"Adresse de réception...",
       "qsrjsdz":"Entrez l'adresse de réception",
       "sjdz":"Arrivée réelle : ",
       "sxf":"Frais: ",
       "txsm1":"Les retraits nécessitent des frais de 5 %, qui doivent être confirmés par le nœud du réseau avant de pouvoir être crédités.",
       "txsm2":"Veuillez ne pas transférer de crypto-monnaies à des étrangers",
       "tz":"Notifier",
       "wdyq":"Mon invitation",
       "yhid":"UID",
       "hdjl":"Obtenez des récompenses en USD",
       "yqsm":"Invitez vos amis à participer à la quantification de l'IA, à louer des machines de minage et à échanger des produits pour obtenir des récompenses en cryptomonnaies",
       "yqsy":"Revenus d'invitation",
       "yqrs":"Nombre de personnes invitées",
       "tgljyq":"Inviter via un lien",
       "lj":"Lien",
       "yqm":"Code d'invitation",
       "cbtb":"Dépôt retirer",
       "jymx":"Détails de la transaction",
       "yqhyjl":"Récompenses pour avoir invité des amis",
       "aidd":"Ordres de trading Golden AI",
       "jdls":"Historique du prêt",
       "etfdd":"Ordres d'ETF",
       "jmhbdd":"Commandes de crypto-monnaie",
       "whdd":"Ordres Forex",
       "gpdd":"Commandes de stock",
       "qx":"Annuler",
       "zc":"Actifs",
       "zzc":"Actif total",
       "ky":"Disponible",
       "zh2":"Converti (USDT)",
       "xzbz":"Sélectionner: ",
       "sztkts":"Important : veuillez vous rendre dans le Centre de sécurité pour définir un mot de passe de transaction.",
       "jymm":"Mot de passe de transaction",
       "szjymm":"Définir le mot de passe de transaction",
       "qsrjymm":"Mot de passe de transaction",
       "zdsl":"Quantité minimale.",
       "bq":"Balise (mémo)",
       "qsrbq":"Saisir la balise",
       "yhktx":"virement",
       "yhmc":"Nom de banque",
       "qsryhmc":"Entrez le nom de la banque",
       "yhzh":"Compte bancaire",
       "qsryhzh":"Entrez le numéro de compte bancaire",
       "gjhkdm":"Code rapide",
       "qsrgjhkdm":"Entrez le code SWIFT",
       "yhdz":"adresse de la banque",
       "qsryhdz":"Entrez l'adresse de la banque",
       "skrxm":"Le nom du bénéficiaire",
       "qsrskrxm":"Entrez le nom du bénéficiaire",
       "skrdh":"Numéro de téléphone du bénéficiaire",
       "qsrskrdh":"Saisissez le numéro de téléphone du bénéficiaire",
       "skrdz":"Adresse du bénéficiaire",
       "qsrskrdz":"Saisissez l'adresse du bénéficiaire",
       "tbjl":"Dossier de retrait",
       "fzcg":"Copié avec succès",
       "aqzx":"Centre de sécurité",
       "yxrz":"Authentification par email",
       "ybd":"Lié",
       "wbd":"Pas liée",
       "yrz":"Vérifié",
       "wrz":"Non certifié",
       "ts":"Pour protéger votre compte, il est recommandé de lier votre adresse e-mail",
       "qsryxdz":"Entrez l'e-mail",
       "dlmm":"Mot de passe",
       "mbwtsz":"Paramètres des problèmes de sécurité",
       "mbwt":"Problème de sécurité",
       "qtxda":"Veuillez remplir la réponse",
       "zyts":"Important: ",
       "zytsCont":"Veuillez ne pas divulguer la réponse de sécurité et le code de vérification, et n'oubliez pas la question de sécurité, qui vous aidera à récupérer votre mot de passe.",
       "qsrxmm":"entrer un nouveau mot de passe",
       "sydqmmcz":"Réinitialiser avec le mot de passe actuel",
       "zhmm":"Problème de sécurité pour récupérer le mot de passe",
       "ysz":"A été mis en",
       "tg":"ignorer",
       "qsrdlmm":"Tapez votre mot de passe",
       "bzxz":"Sélectionner: ",
       "zwsj":"Pas de données",
       "qd":"D'ACCORD",
       "zsgd":"Montre plus",
       "zdss":"Taille minimale du lot",
       "mnjy":"Trading simulé",
       "sx":"Filtrer",
     },
     "zb":{
       "tgdd":"Commandes gérées par l'IA",
       "tgz":"En garde à vue",
       "ysh":"Racheté",
       "shz":"Annulé",
       "zq":"Faire du vélo: ",
       "tian":"Jour",
       "syl2":"Taux de retour: ",
       "rgjg":"Prix ​​de l'abonnement: ",
       "rgjg2":"Prix ​​de l'abonnement",
       "xdsj":"Temps de commande: ",
       "yhl":"Bénéficié : ",
       "syts":"Le nombre de jours restant : ",
       "sh":"Rachat",
       "syl":"Taux de retour",
       "bz":"Nom",
       "dl":"Taux de change",
       "tgts":"Jours d'hébergement : ",
       "tgsl":"Quantité d'hébergement",
       "qsrtgsl":"Entrez la quantité d'hébergement",
       "dbxe":"Limite de transaction unique",
       "ljtg":"Héberger maintenant",
       "zztg":"Fonds en garde",
       "yjjrsy":"Gains estimés aujourd'hui",
       "ljsy":"Revenu cumulé",
       "tgzdd":"Ordonnance de garde à vue",
       "ljzc":"Transférer maintenant",
       "gz":"Règle",
       "cpzq":"Cycle de produit",
       "gm":"Acheter",
       "ts":"Important",
       "shts":"Vous êtes en cours d'opération de rachat, et vous perdrez 5% si vous rachètez avant l'échéance. Etes-vous sûr de racheter ?",
       "xgcs":"Limiter le nombre d'achats",
     },
     "dk":{
       "dk":"Prêt",
       "dkzh":"Compte de prêt",
       "yzsf":"Vérifiez votre identité et obtenez plus de montants de prêt !",
       "ksyz":"Commencer la vérification",
       "wxj":"Je veux emprunter...",
       "dkqx":"Durée du prêt (jours) : ",
       "mrll":"Taux d'intérêt journalier : ",
       "lxze":"Intérêt total : ",
       "dkts":"Aucun intérêt n'est requis sur le prêt pendant 3 jours, et des intérêts peuvent être payés par la suite",
       "xzj":"Prêter maintenant",
       "wyydbzx":"Accepter",
       "dkfwxy":"<Contrat de service de prêt>",
       "dkfwxy2":"Accord de service de prêt",
       "dkysxy":"Accord de confidentialité du prêt",
       "dkjl":"Historique du prêt",
       "hth":"Non.",
       "yfk":"Décaissé",
       "lx":"Intérêt: ",
       "zhke":"Montant total du remboursement : ",
       "znj":"Frais de retard : ",
       "znjl":"Tarif des frais de retard: ",
       "yqts":"Jours en retard: ",
       "qhk":"Pour rembourser",
       "tpsc":"Prêt de crédit (téléchargement d'image)",
       "fwxx":"Informations sur le logement",
       "srzm":"Justificatif de revenus (relation de travail)",
       "yhmx":"coordonnées bancaires",
       "zjz":"Photo d'identité",
       "ljdk":"Prêter maintenant",
       "xm":"Nom",
       "ndxm":"votre nom",
       "qsrndxm":"Entrez votre nom",
       "gj":"Pays",
       "ndgj":"Votre pays",
       "qsrndgj":"Entrez votre pays",
       "dz":"Adresse",
       "nddz":"Votre adresse",
       "qsrnddz":"Entrez votre adresse",
       "csrq":"Date de naissance",
       "ndcsrq":"Votre date de naissance",
       "qsrndcsrq":"Entrez votre date de naissance",
       "dhhm":"Numéro de téléphone",
       "nddhhm":"Votre numéro de téléphone",
       "qsrnddhhm":"Entrez votre numéro de téléphone",
       "zj":"Documents",
       "sfzm":"Identité positive",
       "qscsfzm":"Téléchargez le côté positif de votre identité",
       "sffm":"Le contraire de l'identité",
       "qscsffm":"Téléchargez le verso de votre identité",
       "ddqr":"Confirmation de commande",
       "jk":"Prêt: ",
       "dkqx2":"Durée du prêt: ",
       "qrxd":"Confirmer la commande",
       "yhkxq":"Détails du remboursement dû",
       "hkqr":"Confirmation de remboursement",
       "yhk":"Remboursement dû : ",
       "jksj":"Durée d'emprunt : ",
       "ljhk":"Remboursez immédiatement",
     },
     "jy":{
       "rq":"date",
       "qqjy":"Enregistrement d'options",
       "hyjy":"Contracter",
       "qqhy":"Possibilités",
       "dqwt":"En attente",
       'wtz':"En Commission",
       "hyjl":"Dossier de contrat",
       "shou":"Beaucoup",
       "dk":"O : ",
       "zhjg":"Dernier: ",
       "jyfy":"Frais de transaction: ",
       "kfsj":"Horaires d'ouvertures: ",
       "gg":"Levier: ",
       "pl":"Lot: ",
       "kpj":"Prix d'ouverture : ",
       "yk":"Profit et perte: ",
       "cd":"Annuler la commande",
       "jsj":"Prix ​​de règlement: ",
       "fx":"Direction: ",
       "jgsj":"Délai de livraison: ",
       "gb":"Fermer",
       "jxxd":"Continuer",
       "xj":"Limite: ",
       "gm":"Acheter: ",
       "sl":"Quantité",
       "fy":"Coût: ",
       "tzbzj":"Ajuster la marge",
       "zyzs":"Prenez des bénéfices et stoppez les pertes",
       "pc":"Position fermée",
       "mr":"Acheter",
       "zjbzj":"Augmenter la marge",
       "jsbzj":"Réduire la marge",
       "yxhy":"négociation de contrats: ",
       "cc":"Poste(s) : ",
       "cc2":"Position",
       "cwbzk":"Marge de position : ",
       "zdzjbzj":"Augmentation maximale de la marge : ",
       "zjbzj2":"Augmenter la marge : ",
       "qsrzbzj":"Veuillez saisir le dépôt",
       "yxhy2":"Perpétuel",
       "kp":"Peut être plat",
       "zhang":"Ouvrir",
       "xj2":"Limite",
       "zy":"Tirer profit",
       "zs":"Arrêter la perte",
       "ssjyzl":"Rechercher un type de transaction",
       "ddb":"Carnet de commande",
       "di":"L : ",
       "gao":"H : ",
       "gb2":"C : ",
       "fz":"Minute",
       "mai":"Achat: ",
       "zhang2":"Augmenter",
       "tie":"Automne",
       "sy":"Retour",
       "kz":"Haussier",
       "kt":"Baissier",
       "bndy":"Ne peut pas être inférieur à",
       "sxbzj":"Dépôt de garantie requis : ",
       "ky":"Disponible: ",
       "sj":"Marché",
       "mc":"Vendre",
       "zxtzsl":"Quantité minimum",
       "min":"Montant minimal",
       "max":"Montant le plus élevé",
       "yebz":"Solde insuffisant",
       "ddz":"En attendant",
       "wtzl":"Montant des commissions : ",
       "wtjg":"Prix des commissions : ",
       "ycd":"Annulé",
       "lswt":"Historique",
       "qsrzyjg":"Veuillez saisir le prix du take profit",
       "qsrzsjg":"Veuillez entrer le prix stop loss",
       "ccsl":"Nombre de postes : ",
       "ccjg":"Prix du poste : ",
       "ggbs":"Tirez parti de plusieurs : ",
       "zy2":"Tirer profit: ",
       "zs2":"Arrêter les pertes : ",
       "zje":"Montant forfaitaire: ",
       "ss":"Beaucoup : ",
       "kcjg":"Prix d'ouverture : ",
       "bzjl":"Taux de marge : ",
       "lscc":"Positions historiques",
       "gmj":"Prix ​​d'achat: ",
       "guadan":"Commande en cours",
       "dqjg":"Prix ​​actuel: ",
       "gdjg":"Prix de la commande en attente : ",
       "pcjg":"Le dernier prix: ",
       "ccsj":"Temps de maintien de la position : ",
       "gdsj":"Délai d'attente de la commande : ",
       "pcsj":"Heure de fermeture: ",
       "fdjyk":"Résultat net flottant",
       "pcsl":"Quantité de clôture",
       "qrpc":"Confirmer la clôture de la position",
       "ypc":"Poste fermé",
       "ss2":"Beaucoup",
       "qsrss":"Entrez la taille du lot",
     },
     "gjrz":{
       "sfyz":"Certification KYC",
       "t1":"1. Prend en charge les images au format JPG, JPEG ou PNG inférieures à 8 Mo.",
       "t2":"2. La photo d’identité doit être claire et aucune modification ou blocage n’est autorisé. Le portrait, le numéro d'identification et le nom doivent être clairement visibles.",
       "t3":"3. La photo doit être prise sans chapeau et il est recommandé de ne pas se maquiller. Les traits du visage de la personne qui détient le document doivent être clairement visibles et tout le bras doit être exposé.",
       "t4":"D'ACCORD",
       "bh":"Rejeter",
       "shz":"À l'étude",
       "shtg":"Examen réussi",
       "nyrzcg":"Vous avez été authentifié avec succès",
       "sczjz":"Télécharger une photo d'identité",
       "sczjzmz":"Téléchargez une photo de face de votre pièce d'identité",
       "sczjbmz":"Téléchargez la photo au dos de votre pièce d'identité",
       "scgrqmz":"Téléchargez une photo de votre carte d'identité en main",
       "gjlb":"Liste des pays",
       "qxzgjlb":"Sélectionnez un pays/une région",
       "zsxm":"Nom réel",
       "qsrzsxm":"Entrez votre vrai nom",
       "zjlx":"Type de certificat: ",
       "zjhm":"Numéro d'identification",
       "qsrzjhm":"Entrez votre numéro d'identification",
       "khh":"Banque d'ouverture de compte",
       "qsrkhh":"Entrez la banque d'ouverture du compte",
       "yhkh":"Numéro de carte bancaire",
       "qsryhkh":"Saisir le numéro de carte bancaire",
     },
     "status":{
       "statusText":['Échec','En cours de révision','Succès'],
     },
     "download":{
       "t1":"Trading mobile, à tout moment et en tout lieu",
       "xz":"Télécharger",
     },
     "langNew":{
       "szhb": "Crypto-monnaie",
       "gjs": "Métal",
       "ny": "Énergie",
       "yy": "Brut",
       "jy": "Commerce",
       "jmhb": "Crypto-monnaie",
       "yxhy": "Contrat perpétuel",
       "gdjy": "commande en cours",
       "khh": "Banque d'ouverture de compte",
       "qsrkhh": "Veuillez saisir la banque",
       "yhkh": "Numéro de la carte bancaire",
       "qsryhkh": "Veuillez entrer votre numéro de carte bancaire",
       "mnzh":"Compte démo",
       "zjjypt":"Meilleure plateforme de trading",
       "brjmzndxq":"Ce logiciel répond à tous vos besoins avec la meilleure expertise technique",
       "jx":"Continuer",
       "yssm":"Déclaration de confidentialité",
       "fxqzc":"Politique anti-blanchiment d'argent",
       "jgxkz":"Licence réglementaire",
       "ckgd":"Plus",
       "gd":"Plus",
       "dd":"Commande",
       "ckdd":"Voir les commandes",
       "yxdd":"Perpétuel",
       "qqdd":"Possibilités",
       "hand":"Beaucoup= ",
       "lxwm":"Contactez-nous",
       "tpfzl":"Placez votre image ici, ou ",
       "liulang":"parcourez",
       "zctpgs":"Prise en charge : JPG, JPEG2000, PNG",
       "ysr":"Revenu mensuel",
       "ndysr":"Votre revenu mensuel",
       "qsrndysr":"Entrez votre revenu mensuel",
       "yqtzje":"Montant de l'investissement prévu",
       "qsrtzje":"Saisissez le montant de l'investissement prévu",
       "zszh":"Vrai compte",
       "qdl":"Veuillez vous connecter",
       "zx":"Favoris",
       "hkdz":"Adresse de remboursement",
       "dkje":"Montant du prêt: ",
       "zlx":"Intérêt total: ",
       "hkze":"Remboursement total: ",
       "qcz":"Aller au dépôt",
       "yebz":"Votre solde est insuffisant, veuillez recharger",
       "dhje":"Montant à rembourser：",
       "hkjl":"Ordre de remboursement：",
       "hkje":"Solde disponible：",
       "kyye":"Remboursement：",
       "qb": 'Tous',
       "lmc": "Nom de la chaîne：",
       "search": "Recherche",
       "mrjg":"Prix",
       "lxkf":"Contact",
       "wyj":"Dommages-intérêts",
       "yxsj":"Courir：",
       "jssj":"Finition：",
       "hksj":"Remboursement：",
       "sysj":"Temps restant：",
       "jkqx":"Durée du prêt：",
       "yq":"En retard：",
       "qqss":"Votre ordre de négociation d'options a expiré et votre perte est",
       "qqlr":"Votre ordre de négociation d'options a expiré et votre profit est",
       "bz":"Devise",
       "dzje":"Montant reçu",
       "lxyxzc":"Assistance par e-mail",
     },
     "langNew9":{
     "dzje":"Tendances du marché des produits de trading",
     "lxyxzc":"Commencez votre parcours de trading numérique",
     "text1":"Commencez par créer un compte",
     "text2":"Invitez des amis à rejoindre FXSFC pour jouer ensemble",
     "text3":"Rechargez votre compte",
     "text4":"Prend en charge plusieurs recharges de devises, vous permettant de commencer rapidement à trader",
     "text5":"Commencez à trader",
     "text6":"Fournissez une variété de paires de trading de haute qualité parmi lesquelles choisir et tradez en toute tranquillité dans FXSFC",
      "text7": "Invitez des amis pour gagner des USDT",
      "text8": "Invitez des amis pour gagner facilement des USDT",
      "text9": "La fonction de prêt est en ligne",
      "text10": "Lorsque vous n'avez pas d'argent, vous pouvez demander un prêt, qui sera émis au plus tôt le jour même",
     "text11": "Trader tous les actifs",
     "text12": "Forex, crypto-monnaies, contrats à terme, ETF, etc",
     },
    "bank":{
      "text1":"Votre plateforme de gestion financière la plus fiable",
      "text2":"Alertes d'actualité en temps réel",
      "text3":"Comprendre les informations en temps réel sur le secteur financier",
      "text4":"commencer à comprendre",
      "text5":"flash d'information",
      "text6":"Choisir la banque",
      "text7":"carte bancaire",
      "text8":"Montant...",
      "text9":"Ajouter une carte bancaire",
      "text10":"compte bancaire",
      "text11":"Veuillez saisir le compte bancaire",
      "text12":"Identifiant de la carte",
      "text13":"Veuillez saisir le numéro d'identification de la carte",
      "text14":"code bancaire international",
      "text15":"code bancaire international",
      "text16":"Veuillez entrer le numéro de téléphone",
      "text17":"Ajouter à",
      "text18":"Supprimer la carte bancaire",
      "text19":"Arrivée réelle",
      "text20":"Informations sur le retrait",
      "text21":"Sélectionner la carte bancaire",
      "text22":"Remarques",
      "text23":"Montant minimum de retrait :",
      "text24":"Le retrait n'est pas autorisé si le montant est inférieur au montant minimum de retrait",
      "text25":"• Pour assurer la sécurité des fonds, lorsque la politique de sécurité de votre compte change ou que le mot de passe change, nous examinerons manuellement le retrait. Veuillez attendre patiemment que le personnel vous contacte par téléphone ou par e-mail.",
      "text26":"• Veuillez vous assurer que votre ordinateur et votre navigateur sont sécurisés pour éviter toute altération ou fuite d'informations.",
      "text27":"• Pour les USD que vous retirez, chaque opération signifie que le montant total des actifs affichés sur la page de retrait que vous possédez sera réduit du montant de retrait correspondant.",
      "text28":"Enregistrement de retrait",
      "text29":"Type de devise Fiat",
    }
     // "langNew2":{
     //   "sy":"Page d'accueil",
     //   "sc":"Marché",
     //   "sclb":"Liste du marché",
     //   "jy":"Commerce",
     //   "zh":"Compte",
     //   "db":"Prêts",
     //   "zchm":"Numéro d'enregistrement",
     //   "cp":"Produit",
     //   "tzjd":"Prêts d'investissement",
     //   "zxzc":"Support en ligne",
     //   "xd":"Commande",
     //   "zzjptgmnr":"Investissez dans votre avenir. Développez votre portefeuille dans un système financier équitable et ouvert.",
     //   "yy":"Application",
     //   "pqnr":"Une banque mobile qui s'affranchit des règles traditionnelles et met à votre disposition des outils précis de gestion financière.",
     //   "jiami":"Cryptomonnaie",
     //   "tgnr":"En effectuant des dépôts en utilisant la cryptographie, vous bénéficiez d'un niveau de sécurité supplémentaire et garantissez un traitement rapide des transactions.",
     //   "jyl":"Volume des échanges sur 24 heures",
     //   "ssjmhb":"Liste des cryptomonnaies",
     //   "zchy":"Utilisateurs enregistrés",
     //   "djxz":"Cliquez pour télécharger",
     //   "azsc":"Marché Android",
     //   "pgsd":"Apple Store",
     //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
     // }
  }



// WEBPACK FOOTER //
// ./src/lang/fr.js